export const fontFamily = {
  proximaVara: "'Proxima Vara', sans-serif, Helvetica, Arial, Verdana, Tahoma",
  robotoMono: "'Roboto Mono', monospace, Helvetica, Arial, Verdana, Tahoma",
};

export const Fonts = {
  '--font-proxima-vara': fontFamily.proximaVara,
  '--font-roboto-mono': fontFamily.robotoMono,
};
